/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '@/application';
import { SupplyStepperPageService } from '../../../services';

const MODULE_NAME = 'profile.machines.states.transaction';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.SupplyStepperPageService'
  ) as SupplyStepperPageService;
};

export const createTransaction = async (context: any, event: any) => {
  const currentState = 'CREATE_TRANSACTION';
  const method = 'createTransaction';

  return new Promise(async (resolve, reject) => {
    try {
      const srv = getSrv();
      const createTransaction = await srv?.submitTransaction(event?.payload);
      if (createTransaction) {
        return resolve({
          key: 'CREATE_TRANSACTION',
          value: createTransaction,
        });
      } else {
        const msg = 'Page content not found';
        return reject({
          key: 'CREATE_TRANSACTION',
          value: msg,
        });
      }
    } catch (err: any) {
      return reject({
        key: 'CREATE_TRANSACTION',
        value: err?.message,
      });
    }
  });
};
